import React from 'react';
import styles from '../styles/GameSelection.module.css';
import { idStr } from '../utils/entityIds';

const GameSelection = ({ games, selectedGames, onGameSelection, isDisabled = false }) => {
  const selectedSet = new Set((selectedGames || []).map(idStr));
  return (
    <div className={styles.gameSelection}>
      {games.map((game) => {
        const gameId = idStr(game._id ?? game.id);
        return (
          <label key={gameId || game.name} className={`${styles.gameItem} ${isDisabled ? styles.disabled : ''}`}>
            <input
              type="checkbox"
              checked={selectedSet.has(gameId)}
              onChange={() => onGameSelection(gameId)}
              disabled={isDisabled}
              className={styles.checkbox}
            />
            <span className={styles.gameLabel}>
              {game.name} ({game.gameCode})
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default GameSelection;
